import React from 'react';

export const BenefitsSection: React.FC = () => {
  return (
    <section id="benefits" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Transform Your Practice's Financial Future
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Partner with Ad Astra and experience the confidence that comes from having complete financial clarity and strategic direction for your practice.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl p-12 border border-gray-100">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-16">
            What You Can Expect Working with Ad Astra
          </h3>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="text-center group">
              <div className="relative mb-8">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mx-auto shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
                  <i className="ri-money-dollar-circle-line text-white text-3xl"></i>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Make More Money</h4>
              <p className="text-gray-600 leading-relaxed text-lg">
                Unlock new revenue opportunities and keep more of what you earn with smarter systems and clear financial strategies that help your practice grow.
              </p>
            </div>

            <div className="text-center group">
              <div className="relative mb-8">
                <div className="w-20 h-20 bg-gradient-to-br from-emerald-600 to-teal-600 rounded-2xl flex items-center justify-center mx-auto shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
                  <i className="ri-save-line text-white text-3xl"></i>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Save More Money</h4>
              <p className="text-gray-600 leading-relaxed text-lg">
                Cut unnecessary costs, streamline operations, and stop losing profits to inefficiencies and outdated processes.
              </p>
            </div>

            <div className="text-center group">
              <div className="relative mb-8">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-600 to-red-600 rounded-2xl flex items-center justify-center mx-auto shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
                  <i className="ri-bar-chart-line text-white text-3xl"></i>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Understand Your Money</h4>
              <p className="text-gray-600 leading-relaxed text-lg">
                Gain clear visibility into where your money's going, what's driving your profits, and how to make confident, data-driven decisions for your practice's future.
              </p>
            </div>
          </div>

          <div className="mt-16 text-center">
            <div className="mb-8">
              <img 
                src="https://static.readdy.ai/image/c3872b68606455811b2742ce5d42b89c/2f792256062dbcb5c192f26f00157bb0.jpeg"
                alt="Professional financial consultation and practice transformation"
                className="mx-auto rounded-2xl shadow-lg max-w-md w-full h-auto object-cover"
              />
            </div>
            <div className="inline-flex items-center space-x-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full shadow-lg">
              <i className="ri-star-fill text-yellow-300 text-xl"></i>
              <span className="text-lg font-semibold">Ready to transform your practice's financial future?</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
